import { useState } from "react"
import { FormError, FormLabel, Modal } from "../../../components/common"
import { useFormErrors } from "../../../components/hooks"
import { VALIDATION_MESSAGE } from "../../../consts/validationMessage"
import { TIPS } from "../../../consts/tips"

const FirmaDigitalObservacionModal = ({ action, onConfirm, onCancel }) => {
    const [observacion, setObservacion] = useState('')

    const observacionObligatoria = action === 'rechaza'

    const getErrors = () => {
        const errors = {}

        if (observacionObligatoria && observacion.length === 0) errors.observacion = VALIDATION_MESSAGE.REQUIRED

        return errors
    }

    const { errorOf, validate } = useFormErrors(getErrors)

    const handleClickAceptar = () => {
        if (!validate()) return

        onConfirm(observacion)
    }

    return <Modal
        onEscape={onCancel}
        show
        title={action === 'firma' ? 'Firmar' : 'Rechazar' + ' archivo'}
        tipName={TIPS.NAME.MODALS.FIRMA_DIGITAL_OBSERVACION_MODAL}
        body={(
            <div className="row form-basic">
                <div className="col-12 col-md-12">
                    <FormLabel htmlFor="observacion" required={observacionObligatoria}>Observación</FormLabel>
                    <input
                        name="observacion"
                        type="text"
                        placeholder=""
                        className={`form-control ${errorOf('observacion') ? 'is-invalid' : ''}`}
                        value={observacion}
                        onChange={({ target }) => setObservacion(target.value)}
                    />
                    <FormError message={errorOf('observacion')} />
                </div>
            </div>
        )}
        footer={<>
            <button className="btn btn-outline-primary" data-dismiss="modal" onClick={onCancel}>Cancelar</button>
            <button className="btn btn-primary" data-dismiss="modal"  onClick={handleClickAceptar}>Aceptar</button>
        </>}
    />
}

export default FirmaDigitalObservacionModal
